import { createSlice } from "@reduxjs/toolkit"

export const TOOL_PANEL_VIEW = {
	RECENTLY_VIEWED: "RECENTLY_VIEWED",
	UNASSIGNED: "UNASSIGNED",
}

export const toolPanelViewSlice = createSlice({
	name: "toolPanelView",
	initialState: {
		byWorkspace: {}
	},
	reducers: {
		setToolPanelView: (state, action) => {
			const {view, workspaceId} = action.payload
			state.byWorkspace[workspaceId] = view
		},
	},
})

export const { setToolPanelView } = toolPanelViewSlice.actions

export const selectToolPanelView = (state, workspaceId) => state.toolPanelView.byWorkspace?.[workspaceId] ?? null

export default toolPanelViewSlice.reducer
